import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

export const firebaseConfig = {
  apiKey: 'AIzaSyCQiEfetTjaB5u1-3S9QfrCWxl0_6ZkI7o',
  authDomain: 'ddhapps-49ba0.firebaseapp.com',
  projectId: 'ddhapps-49ba0',
  storageBucket: 'ddhapps-49ba0.firebasestorage.app',
  messagingSenderId: '1019828240651',
  appId: '1:1019828240651:web:bc1e8285e89fb0a445a20e',
  measurementId: 'G-ML63C9RQKJ',
};

const app = initializeApp(firebaseConfig, 'ddhapps');
export const db = getFirestore(app);
export const auth = getAuth(app);
